"use client";
import { useQuery } from "@apollo/client";

import { useIsAuthGraphQLReady } from "@stadium/services/auth/client";

/**
This hook is used to fetch data from authenticated queries.
To know if a request has been made, check the `called` property.
 */

export const useAuthQuery: typeof useQuery = (query, options) => {
  const isAuthGraphQLReady = useIsAuthGraphQLReady();

  return useQuery(query, {
    ...options,
    skip: options?.skip || !isAuthGraphQLReady,
  });
};
